module.exports = __webpack_public_path__ + "img/hero-renegades-le_rfu.bd008f2.jpg";